import Hls from 'hls.js';
import { SearchCondition } from 'commons/constants/KeyFlowConstants';
import {
  AssetState,
  CategoryState,
  CodeState,
  LibraryState,
  ModalState,
  WkblScriptState,
  ScriptState,
  StorageState,
  UserState,
  WkblVideoState,
  WkblSpecialVideoState,
  VideoState,
  PreferenceState,
  ErrorState,
  NotificationState,
  ConfigState,
  DownloadState,
  LibraryNotificationState,
  StatisticsTypeState,
  StatisticsAssetState,
  StatisticsStorageState,
  StatisticsLogStreamingState, AwsInit,
} from 'redux/reducers/type';
import ConfigVO from 'commons/vo/ConfigVO';

export const userInit: UserState = {
  isLoading: false,
  isLoggedIn: true,
  unValidated: false,
  userId: '',
  userName: '',
  errorMessage: '',
};

export const assetInit: AssetState = {
  isLoading: false,
  resultList: [],
  selectedAsset: null,
  selectedTeam1: null,
  selectedTeam2: null,
  quarterList: [],
  isQuarterListLoading: false,
  selectedQuarter: null,

  pagination: {
    itemCount: 0,
    pageNumber: 0,
    pageCount: 0,
  },
  asc: SearchCondition.Asc.DESC,
  sort: SearchCondition.Sort.DATE_OF_GAME,
};

export const storageInit: StorageState = {
  isInit: false,
  isLoading: false,
  storageList: [],
};

export const categoryInit: CategoryState = {
  isInit: false,
  isLoading: false,
  categoryList: [],
};

export const wkblScriptInit: WkblScriptState = {
  isLoading: false,
  wkblScriptList: [],
  pagination: {
    itemCount: 0,
    pageNumber: 0,
    pageCount: 0,
    returnCount: 12,
  },
  searchCondition: {
    sort: SearchCondition.Sort.DATE_OF_GAME,
    asc: SearchCondition.Asc.DESC,
    page: 0,
    retr: 12,
  },
};

export const downloadInit: DownloadState = {
  downloadingGroup: {},
};

export const wkblVideoInit: WkblVideoState = {
  isLoading: false,
  videoList: [],
  downloadingGroup: {},
  pagination: {
    itemCount: 0,
    pageNumber: 0,
    pageCount: 0,
    returnCount: 12,
  },
  searchCondition: {
    season: '',
    gameTypes: [],
    gameDateFrom: '',
    gameDateTo: '',
    sort: SearchCondition.Sort.DATE_OF_GAME,
    asc: SearchCondition.Asc.DESC,
    page: 0,
    retr: 12,
  },
};

export const wkblSpecialVideoInit: WkblSpecialVideoState = {
  isLoading: false,
  specialVideoList: [],
  downloadingGroup: {},
  pagination: {
    itemCount: 0,
    pageNumber: 0,
    pageCount: 0,
    returnCount: 12,
  },
  searchCondition: {
    sort: SearchCondition.Sort.DATE_OF_GAME,
    asc: SearchCondition.Asc.DESC,
    page: 0,
    retr: 12,
  },
};

export const scriptInit: ScriptState = {
  isLoading: true,
  isLoadingByWheel: false,
  isLoadingPut: false,
  selectedScript: null,
  scriptList: [],
  keyword: '',
  pagination: {
    itemCount: 0,
    pageNumber: 0,
    pageCount: 0,
  },
  message: '',
  putError: false,
};

export const libraryInit: LibraryState = {
  isLoading: false,
  isLoadingInsert: false,
  libraryList: [],
  jobList: [],
  libraryCount: 0,
  waitingCount: 0,
  pagination: {
    itemCount: 0,
    pageNumber: 0,
    pageCount: 0,
  },
};

export const StatisticsAssetInit: StatisticsAssetState = {
  isLoading: false,
  statistics: [],
};

export const StatisticsPartialInit: StatisticsTypeState = {
  isLoading: false,
  statistics: [],
};

export const StatisticsDownloadInit: StatisticsTypeState = {
  isLoading: false,
  statistics: [],
};

export const StatisticsStreamingInit: StatisticsTypeState = {
  isLoading: false,
  statistics: [],
};

export const StatisticsLoginInit: StatisticsTypeState = {
  isLoading: false,
  statistics: [],
};

export const StatisticsStorageInit: StatisticsStorageState = {
  isLoading: false,
  statistics: [],
};

export const statisticsLogStreamingInit: StatisticsLogStreamingState = {
  isLoading: false,
  streamingCount: 0,
};

export const libraryNotificationInit: LibraryNotificationState = {
  waitingIdList: {},
};

export const codeInit: CodeState = {
  isInit: false,
  isLoading: false,
  videoTypeList: [],
  wkblGameTypeList: [],
  wkblDateGameTypeList: [],
  wkblSpecialGameTypeList: [],

  kfScriptRefRangeList: [],
  wkblSeasonList: [],
  kfScriptTypeList: [],
};

export const modalInit: ModalState = {
  isOpen: false,
  body: null,
};

export const videoInit: VideoState = {
  isLoading: false,
  isError: false,

  inTime: 0,
  outTime: 0,
  currentTime: 0,
  duration: 0,

  inPoint: 0,
  outPoint: 0,

  currentTimecode: '00:00:00',
  durationTimecode: '00:00:00',

  fps: 0,
};

export const preferenceInit: PreferenceState = {
  isInit: false,
  isLoading: false,
  preferences: {
    video: null,
    videoLibrary: null,
    banner: null,
  },
};

export const configInit: ConfigState = {
  isInit: false,
  isLoading: false,
  config: new ConfigVO({ FORCED_HIDE_TEAM: [], FORCED_SHOW_TEAM: [] }),
};

export const errorInit: ErrorState = {
  error: null,
};

export const notificationInit: NotificationState = {
  notifications: [],
};

export const awsInit: AwsInit = {
  exist: false,
  isLoading: false,
}
